import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider, Spin } from "antd";
import srRS from "antd/locale/sr_RS";
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import AuthenticatedRoute from './components/layout/AuthenticatedRoute';
import AppUpdateWatcher from './components/layout/AppUpdateWatcher';
import { ThemeProvider, useAppTheme } from "./contexts/ThemeContext";
import "./styles.css";

const Login = lazy(() => import('./pages/Login'));
const Logout = lazy(() => import('./pages/Logout'));
const MainContainer = lazy(() => import('./pages/MainContainer'));
const CompanyAdmin = lazy(() => import('./pages/CompanyAdmin'));

const RouteFallback = () => (
    <div className="auth-route-loading">
        <Spin size="large" />
    </div>
);

const ThemedApp = () => {
    const { theme } = useAppTheme();

    return (
        <ConfigProvider
            theme={theme.antd}
            locale={{
                ...srRS,
                Pagination: {
                    ...srRS.Pagination,
                    items_per_page: '/ strani',
                    jump_to: 'Idi na',
                    jump_to_confirm: 'potvrdi',
                    page: '',
                    prev_page: 'Prethodna strana',
                    next_page: 'Sledeća strana',
                    prev_5: 'Prethodnih 5 strana',
                    next_5: 'Sledećih 5 strana',
                    prev_3: 'Prethodne 3 strane',
                    next_3: 'Sledeće 3 strane',
                    page_size: 'Veličina strane',
                },
            }}
        >
            <Router>
                <div className="app-container">
                    <AppUpdateWatcher />
                    <Header />
                    <div className="app-body">
                        <Suspense fallback={<RouteFallback />}>
                            <Routes>
                                <Route path="/" element={<Login />} />
                                <Route path="/logout" element={<Logout />} />
                                <Route
                                    path="/maps"
                                    element={
                                        <AuthenticatedRoute>
                                            <MainContainer />
                                        </AuthenticatedRoute>
                                    }
                                />
                                <Route
                                    path="/admin"
                                    element={
                                        <AuthenticatedRoute platformAdminOnly>
                                            <CompanyAdmin />
                                        </AuthenticatedRoute>
                                    }
                                />
                            </Routes>
                        </Suspense>
                    </div>
                    <Footer />
                </div>
            </Router>
        </ConfigProvider>
    );
};

const App = () => (
    <ThemeProvider>
        <ThemedApp />
    </ThemeProvider>
);

export default App;
